const o = {
  name: "Food",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 13.9C21.2822 13.4367 23 11.419 23 9V6C23 3.23858 20.7614 1 18 1C15.2386 1 13 3.23858 13 6V9C13 11.419 14.7178 13.4367 17 13.9V22H19V13.9ZM15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6V9C21 10.6569 19.6569 12 18 12C16.3431 12 15 10.6569 15 9V6Z" fill="currentColor"/>
<path d="M3 10V2H1V10C1 11.6523 2.34772 13 4 13H5V22H7V13H8C9.65228 13 11 11.6523 11 10V2H9V10C9 10.5477 8.54772 11 8 11H4C3.45228 11 3 10.5477 3 10Z" fill="currentColor"/>
<path d="M7 2V9H5V2H7Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as Food
};
